import React, { ReactElement } from 'react';
import { InsetText, Text } from 'idsk-react-components';
import LegislativnyMaterialDetail
  from '../../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import '../LegMaterialPripomienkovanieMessage/legMaterialDetailMessage.scss';
import StadiumMaterialuHistoriaList
  from '../../../../../model/legislativnyMaterial/StadiumMaterialuHistoriaList';
import { useUserContext } from '../../../../../context/UserContext';
import { pouzivatelIsAdmin } from '../../../../../function/permissions';
import {
  isActualStadiumLatestRunning,
  isFinalState,
} from '../../../../../function/getLatestStadium';
import errorIcon from '../../../../../../assets/images/icon-error-red.svg';

interface Props {
  legMaterial: LegislativnyMaterialDetail;
  legMaterialHistoriaList: StadiumMaterialuHistoriaList;
}

const LegMaterialNekonzistentneStadiumMessage = ({
  legMaterial,
  legMaterialHistoriaList,
}: Props): ReactElement => {
  const { pouzivatel } = useUserContext();
  const isAdmin = pouzivatelIsAdmin(pouzivatel);
  const userIsLogged = (): boolean => (pouzivatel != null);

  return (userIsLogged()
      && legMaterialHistoriaList
      && !isActualStadiumLatestRunning(legMaterial.stadium.hodnota, legMaterialHistoriaList.historiaRecords)
      && !isFinalState(legMaterial.stadium?.hodnota)
      && (isAdmin || (!isAdmin && legMaterial.hasOpravneniePracovneKroky))) && (
      <div className="material-detail-message-container">
        <InsetText
          id="nekonzistentneStadiumWarning"
          type="warn"
          className="span-red__inset-text"
          icon={errorIcon}
        >
          {isAdmin && (
            <Text type="span" bold>Proces nie je v konzistentnom stave. Aktuálne štádium
              materiálu a prebiehajúce
              štádium v histórii sa nezhodujú. Prosím vykonajte funkcionalitu
              administrátora &quot;Zmena štádia
              materiálu&quot; a zvoľte požadované štádium.
            </Text>
          )}
          {!isAdmin && legMaterial.hasOpravneniePracovneKroky && (
            <Text type="span" bold>Proces nie je v konzistentnom stave. Aktuálne štádium
              materiálu a prebiehajúce
              štádium v histórii sa nezhodujú. Prosím nevykonávajte žiadne zmeny na tomto
              procese a kontaktujte
              administrátora.
            </Text>
          )}
        </InsetText>
      </div>
  );
};

export default LegMaterialNekonzistentneStadiumMessage;
